import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Spinner } from 'reactstrap';
import axios from 'axios';
import config from '../../config.js';
import { store } from '../../store/index.js';
import ScanAndPayOpsFlow from './ScanAndPayOpsFlow';
import { getBlobUrlAndContentType } from '../../utils/getBlobUrlAndContentType.js';
import QRIcon from './QRIcon'; // Adjust path as necessary


const apiRequest = async (url, method = 'GET', data = null) => {
    const headers = {
        'Content-Type': 'application/json',
    };
    const state = store.getState();
    if (state.user.token) {
        headers.Authorization = state.user.token;
    }

    try {
        const response = await axios({
            url,
            method,
            data,
            headers,
        });
        return response.data;
    } catch (err) {
        const errorMessage = err.response && err.response.data && err.response.data.message || err.message;
        throw new Error(errorMessage);
    }
};

// API calls using the helper function
const getScanAndPayCartDetailByCartId = async (cartId) => {
    return await apiRequest(`${config.pharmacyService}/scan-and-pay/fetch-cart-detail?cartId=${cartId}&isSecureDocumentUrl=1`);
};

const getScanAndPayCaseListSummary = async () => {
    return await apiRequest(`${config.pharmacyService}/scan-and-pay/fetch-case-list-summary`);
};

const getCaseList = async ({
    offset = 0,
    caseType = null,
    digitisationRequestId = null,
    phone = null
}) => {
    let url = `${config.pharmacyService}/scan-and-pay/fetch-case-list?offset=${offset}`;

    if (Number(digitisationRequestId))
        url += `&digitisationRequestId=${digitisationRequestId}`;

    if (Number(phone))
        url += `&phone=${phone}`;

    if (caseType)
        url += `&caseType=${caseType}`;

    return await apiRequest(url);
};

const cellStyle = {
    padding: '10px',
    textAlign: 'left',
    borderRight: '1px solid #e0e0e0',
    whiteSpace: 'nowrap'
};

const headerButtonStyle = {
    padding: '10px',
    border: '1px solid #ddd',
    textAlign: 'left',
    backgroundColor: '#f9f9f9',
    fontWeight: 'bold',
    cursor: 'pointer',
    userSelect: 'none',
    transition: 'background-color 0.2s, color 0.2s',
    borderRadius: '10px',
    whiteSpace: 'nowrap',
    boxShadow: 'inset 0 -2px 0 rgba(0, 0, 0, 0.1)'
};


const getCallList = async (cartId) => {
    const url = `${config.pharmacyService}/scan-and-pay/fetch-call-list?cartId=${cartId}`;
    try {
        const response = await apiRequest(url);
        return response;
    } catch (err) {
        throw new Error(err.message);
    }
};

const getOrderList = async (cartId) => {
    const url = `${config.pharmacyService}/scan-and-pay/fetch-order-list?cartId=${cartId}`;
    try {
        const response = await apiRequest(url);
        return response;
    } catch (err) {
        throw new Error(err.message);
    }
};


const getUpiScanList = async (cartId) => {
    const url = `${config.pharmacyService}/scan-and-pay/fetch-upi-scan-list?cartId=${cartId}`;
    try {
        const response = await apiRequest(url);
        return response;
    } catch (err) {
        throw new Error(err.message);
    }
};


const updateCartApprovedAmount = async (cartId, approvedAmount) => {
    return await apiRequest(`${config.pharmacyService}/scan-and-pay/update-cart-approved-amount`, 'POST', { cartId, approvedAmount });
};


const enableScanAndPay = async (digitisationRequestId) => {
    return await apiRequest(`${config.pharmacyService}/scan-and-pay/enable-scan-and-pay`, 'POST', { digitisationRequestId });
};


class PharmacyScanAndPayHome extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cartId: '',
            cartDetails: {
                items: { covered: [], uncovered: [] },
                totalAmount: null,
                requestedAmount: null,
                approvedAmount: null,
                prescriptionUrl: '',
                cartId: null,
            },
            approvedAmount: null,
            error: '',
            loading: false,
            updating: false,
            caseList: [],
            caseListSummary: {},
            caseListLoading: true,
            caseListSummaryLoading: true,
            callListLoading: false,
            orderListLoading: false,
            upiScanListLoading: false,
            offset: 0, // Initial offset for pagination
            limit: 10, // Number of items per page
            caseType: null,
            filterPhone: '',
            filterDigitisationRequestId: '',
            callList: [],
            orderList: [],
            upiScanList: [],
            selectedRowIndex: null,
            isFlowChartOpen: false
        };
    }

    fetchCartDetails = async (cartId = null) => {
        if (!cartId) {
            this.setState({
                cartId: null,
                cartDetails: null,
                approvedAmount: null,
                callList: [],
                orderList: [],
                upiScanList: [],
                loading: false
            });
            return;
        }

        try {
            const data = await getScanAndPayCartDetailByCartId(cartId);

            if (data.success) {
                if (data.cart && data.cart.prescriptionUrl) { 
                    const state = store.getState();
                    if (state.user.token) {
                        data.cart.prescriptionUrl = await getBlobUrlAndContentType({
                            fileUrl: data.cart.prescriptionUrl, 
                            headers: {Authorization: state.user.token}
                        }).then(res => res.blobUrl);
                    }
                }
                this.setState({
                    cartId,
                    cartDetails: data.cart,
                    approvedAmount: null,
                    callList: [],
                    orderList: [],
                    upiScanList: [],
                    error: '',
                    loading: false
                });
            } else {
                this.setState({
                    cartId,
                    error: data.message,
                    approvedAmount: null,
                    callList: [],
                    orderList: [],
                    upiScanList: [],
                    loading: false
                });
            }
        } catch (err) {
            this.setState({
                cartId,
                error: err.message,
                approvedAmount: null,
                callList: [],
                orderList: [],
                upiScanList: [],
                loading: false
            });
        }
    };

    getCaseListSumary = async () => {
        this.setState({ caseListSummaryLoading: true });

        try {
            const data = await getScanAndPayCaseListSummary();
            this.setState({ caseListSummary: data.caseListSummary });
        } catch (err) {
            this.setState({ error: err.message });
        } finally {
            this.setState({ caseListSummaryLoading: false });
        }
    };

    getCaseList = async () => {
        this.setState({ caseListLoading: true, selectedRowIndex: null });
        this.fetchCartDetails();
        const {
            offset,
            caseType,
            filterDigitisationRequestId,
            filterPhone
        } = this.state;

        try {
            const data = await getCaseList({
                offset,
                caseType,
                digitisationRequestId: filterDigitisationRequestId,
                phone: filterPhone
            });

            this.setState({ caseList: data.caseList });
        } catch (err) {
            this.setState({ error: err.message });
        } finally {
            this.setState({ caseListLoading: false });
        }
    };

    getCallList = async () => {
        this.setState({ callListLoading: true });
        try {
            const { cartId } = this.state;
            if (Number(cartId)) {
                const data = await getCallList(cartId);
                this.setState({ callList: data.callList });
            } else {
                this.setState({ error: 'Choose Cart Id First' });
            }
        } catch (err) {
            this.setState({ error: err.message });
        } finally {
            this.setState({ callListLoading: false });
        }
    };

    getOrderList = async () => {
        this.setState({ orderListLoading: true });
        try {
            const { cartId } = this.state;
            if (Number(cartId)) {
                const data = await getOrderList(cartId);
                this.setState({ orderList: data.orderList });
            } else {
                this.setState({ error: 'Choose Cart Id First' });
            }
        } catch (err) {
            this.setState({ error: err.message });
        } finally {
            this.setState({ orderListLoading: false });
        }
    };

    getUpiScanList = async () => {
        this.setState({ upiScanListLoading: true });
        try {
            const { cartId } = this.state;
            if (Number(cartId)) {
                const data = await getUpiScanList(cartId);
                this.setState({ upiScanList: data.upiScanList });
            } else {
                this.setState({ error: 'Choose Cart Id First' });
            }
        } catch (err) {
            this.setState({ error: err.message });
        } finally {
            this.setState({ upiScanListLoading: false });
        }
    };


    handlePrevPage = () => {
        this.setState((prevState) => {
            const newOffset = Math.max(prevState.offset - 1, 0); // Ensure offset doesn't go below 0
            return { offset: newOffset };
        }, () => {
            this.getCaseList();
        });
    };

    handleNextPage = () => {
        this.setState((prevState) => {
            const newOffset = prevState.offset + 1;
            return { offset: newOffset, };
        }, () => {
            this.getCaseList();
        });
    };

    // Handle input change for filters
    handleFilterChange = (filterType, value) => {
        this.setState({ [filterType]: value });
    };

    handleFilterDigitisationRequestIdChange = (event) => {
        this.setState({ filterDigitisationRequestId: event.target.value });
    };

    handleFilterPhoneChange = (event) => {
        this.setState({ filterPhone: event.target.value });
    };

    // Handle input change for cartId
    handleCartIdChange = (event) => {
        const cartId = event.target.value;
        this.setState({ cartId: cartId });
    };

    toggleSteps = () => this.setState({ isFlowChartOpen: !this.state.isFlowChartOpen });

    // Handle input change for digitisationRequestId
    handleEnableDigitisationRequestIdChange = (event) => {
        this.setState({ enableDigitisationRequestId: event.target.value });
    };

    // Handle submit for fetching cart details
    handleCartIdSubmit = () => {
        const { cartId } = this.state;
        if (cartId) {
            this.fetchCartDetails(cartId);
        }
    };

    handleEnableScanAndPay = async () => {
        const { enableDigitisationRequestId } = this.state;

        if (!enableDigitisationRequestId) {
            this.setState({ error: "Please enter a valid digitisationRequestId." });
            return;
        }

        this.setState({ updating: true, error: '' });

        try {
            const response = await enableScanAndPay(this.state.enableDigitisationRequestId);
            if (response.success) {
                this.setState({ updating: false });
            } else {
                this.setState({ error: response.message, updating: false });
            }
            this.setState({ scanAndPayEnabledUpdatedMessage: `Attempt ${response.isUpdated ? 'Success' : 'Failed'} For Digitisation Request Id: ${this.state.enableDigitisationRequestId}` });
        } catch (err) {
            this.setState({ error: err.message, updating: false });
        }
    }

    handleUpdateApprovedAmount = async () => {
        const { approvedAmount } = this.state;

        if (!approvedAmount || approvedAmount <= 0) {
            this.setState({ error: "Please enter a valid approved amount." });
            return;
        }

        this.setState({ updating: true, error: '' });

        try {
            const response = await updateCartApprovedAmount(this.state.cartId, approvedAmount);
            if (response.success) {
                // Fetch the updated cart details
                await this.fetchCartDetails(this.state.cartId);
                this.setState({ updating: false });
            } else {
                this.setState({ error: response.message, updating: false });
            }
        } catch (err) {
            this.setState({ error: err.message, updating: false });
        }
        this.setState({ approvedAmount: null });
    };


    componentDidMount() {
        this.getCaseListSumary();
        this.getCaseList();
    }

    render() {
        const {
            cartId,
            cartDetails,
            error,
            loading,
            updating,
            caseList,
            selectedRowIndex,
            caseListSummary,
            caseListLoading,
            caseListSummaryLoading,
            orderListLoading,
            callListLoading,
            upiScanListLoading,
            offset,
            filterPhone,
            filterDigitisationRequestId,
            orderList,
            callList,
            upiScanList,
            enableDigitisationRequestId,
            scanAndPayEnabledUpdatedMessage
        } = this.state;

        return (
            <section style={{ width: '100%', padding: '20px 40px' }}>
                <h3
                    onClick={this.toggleSteps}
                    style={{
                        position: 'relative', // ensures absolute children are contained
                        display: 'flex',
                        justifyContent: 'center', // center the label
                        alignItems: 'center',
                        textAlign: 'center',
                        fontSize: '20px',
                        fontWeight: '600',
                        margin: '12px 0',
                        paddingTop: '50px',
                        paddingBottom: '25px',
                        minHeight: '48px',
                        color: '#333',
                        backgroundColor: '#f8f9fa',
                        borderRadius: '6px',
                        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                        cursor: 'pointer',
                        userSelect: 'none',
                        minHeight: '48px' // optional: ensures vertical space
                    }}
                >
                    {/* QR Icon on the left */}
                    <div style={{ position: 'absolute', left: '16px', display: 'flex', alignItems: 'center' }}>
                        <QRIcon />
                    </div>

                    {/* Center text */}
                    <span>Pharmacy Scan And Pay</span>

                    {/* Toggle arrow on the right */}
                    <span style={{ position: 'absolute', right: '16px', fontSize: '16px' }}>
                        {this.state.isFlowChartOpen ? '^' : ''}
                    </span>
                </h3>



                {this.state.isFlowChartOpen && (
                    <ScanAndPayOpsFlow onClose={() => this.setState({ isFlowChartOpen: false })} />
                )}


                {error && <p className="text-danger text-center">{error}</p>}
                <hr />

                {/* Number input with button */}
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginBottom: '20px'
                    }}
                >
                    <div
                        style={{
                            width: '500px',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginBottom: '20px'
                        }}
                    >
                        <input
                            type="number"
                            value={enableDigitisationRequestId || ''}
                            onChange={this.handleEnableDigitisationRequestIdChange}
                            placeholder="Digitisation Id"
                            className="form-control"
                            style={{
                                width: '300px',
                                flex: 1,
                                marginRight: '10px'
                            }}
                        />
                        <button
                            onClick={this.handleEnableScanAndPay}
                            className="btn btn-primary"
                            style={{
                                flexShrink: 0
                            }}
                        >
                            Enable
                        </button>
                    </div>
                    {scanAndPayEnabledUpdatedMessage && (
                        <p
                            className="text-su text-center"
                            style={{ marginLeft: '10px' }}
                        >
                            {scanAndPayEnabledUpdatedMessage}
                        </p>
                    )}
                </div>

                {/* Filters for fetching case list */}
                <div style={{
                    padding: '12px',
                    border: '1px solid #ccc',
                    borderRadius: '8px',
                    backgroundColor: '#fdfdfd',
                    fontSize: '13px',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
                    marginBottom: '16px'
                }}>
                    <h6 style={{
                        textAlign: 'center',
                        marginBottom: '12px',
                        fontSize: '15px',
                        fontWeight: '600',
                        color: '#333',
                        userSelect: 'none',
                    }}>Filters</h6>

                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 2fr))',
                        gap: '50px',
                        display: 'flex', flexDirection: 'row'
                    }}>
                        {/* Text Inputs */}
                        <label style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                            <span>Phone</span>
                            <input
                                type="tel"
                                value={filterPhone}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        this.setState({ offset: 0, caseType: null }, this.getCaseList);
                                    }
                                }}
                                onChange={this.handleFilterPhoneChange}
                                placeholder="Phone"
                                className="form-control"
                                style={{
                                    padding: '6px',
                                    borderRadius: '4px',
                                    fontSize: '13px'
                                }}
                            />
                        </label>

                        <label style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                            <span>Digitisation ID</span>
                            <input
                                type="number"
                                value={filterDigitisationRequestId}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        this.setState({ offset: 0, caseType: null }, this.getCaseList);
                                    }
                                }}
                                onChange={this.handleFilterDigitisationRequestIdChange}
                                placeholder="ID"
                                className="form-control"
                                style={{
                                    padding: '6px',
                                    borderRadius: '4px',
                                    fontSize: '13px'
                                }}
                            />
                        </label>

                    </div>
                </div>

                {/* Case List Summary Section */}
                <div className="call-list mt-4">
                    {caseListSummaryLoading ? (
                        <div style={{ textAlign: 'center', padding: '20px' }}>
                            <Spinner />
                        </div>
                    ) : (
                        <div style={{
                            border: '1px solid #ccc',
                            borderRadius: '8px',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                            padding: '10px'
                        }}>
                            <h6 style={{ textAlign: 'center', marginBottom: '16px', color: '#333', userSelect: 'none' }}>
                                Scan And Pay Summary
                            </h6>

                            {/* Scrollable Table */}
                            <div style={{ overflowX: 'auto' }}>
                                <table style={{
                                    width: '100%',
                                    minWidth: '1400px',
                                    borderCollapse: 'collapse',
                                    fontFamily: 'Arial, sans-serif',
                                    fontSize: '14px'
                                }}>
                                    <thead>
                                        <tr style={{ backgroundColor: '#f2f2f2' }}>
                                            <th
                                                style={{
                                                    ...headerButtonStyle,
                                                    border: this.state.caseType == null ? '2px solid gray' : '1px solid #ccc'
                                                }}
                                                onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#e0e0e0')}
                                                onMouseOut={(e) => (e.currentTarget.style.backgroundColor = '#f9f9f9')}
                                                onClick={() => this.setState({ offset: 0, caseType: null, }, this.getCaseList)}
                                            >
                                                Total Cases
                                            </th>
                                            <th
                                                style={{
                                                    ...headerButtonStyle,
                                                    border: this.state.caseType == 'completed' ? '2px solid gray' : '1px solid #ccc'
                                                }}
                                                onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#e0e0e0')}
                                                onMouseOut={(e) => (e.currentTarget.style.backgroundColor = '#f9f9f9')}
                                                onClick={() => this.setState({ offset: 0, caseType: 'completed' }, this.getCaseList)}
                                            >
                                                Completed Cases
                                            </th>
                                            <th
                                                style={{
                                                    ...headerButtonStyle,
                                                    border: this.state.caseType == 'store-payout-stuck' ? '2px solid gray' : '1px solid #ccc'
                                                }}
                                                onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#e0e0e0')}
                                                onMouseOut={(e) => (e.currentTarget.style.backgroundColor = '#f9f9f9')}
                                                onClick={() => this.setState({ offset: 0, caseType: 'store-payout-stuck' }, this.getCaseList)}
                                            >
                                                Store Payout Stuck Cases
                                            </th>
                                            <th
                                                style={{
                                                    ...headerButtonStyle,
                                                    border: this.state.caseType == 'invoice-not-uploaded' ? '2px solid gray' : '1px solid #ccc'
                                                }}
                                                onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#e0e0e0')}
                                                onMouseOut={(e) => (e.currentTarget.style.backgroundColor = '#f9f9f9')}
                                                onClick={() => this.setState({ offset: 0, caseType: 'invoice-not-uploaded' }, this.getCaseList)}
                                            >
                                                Invoice Not Uploaded Cases
                                            </th>
                                            <th
                                                style={{
                                                    ...headerButtonStyle,
                                                    border: this.state.caseType == 'invoice-not-inspected' ? '2px solid gray' : '1px solid #ccc'
                                                }}
                                                onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#e0e0e0')}
                                                onMouseOut={(e) => (e.currentTarget.style.backgroundColor = '#f9f9f9')}
                                                onClick={() => this.setState({ offset: 0, caseType: 'invoice-not-inspected' }, this.getCaseList)}
                                            >
                                                Invoice Not Inspected Cases
                                            </th>
                                            <th
                                                style={{
                                                    ...headerButtonStyle,
                                                    border: this.state.caseType == 'invoice-not-closed' ? '2px solid gray' : '1px solid #ccc'
                                                }}
                                                onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#e0e0e0')}
                                                onMouseOut={(e) => (e.currentTarget.style.backgroundColor = '#f9f9f9')}
                                                onClick={() => this.setState({ offset: 0, caseType: 'invoice-not-closed' }, this.getCaseList)}
                                            >
                                                Invoice Not Closed Cases
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td style={{ padding: '10px', fontWeight: 'bolder', border: '1px solid #ddd' }}>{caseListSummary?.totalCaseCount || 0}</td>
                                            <td style={{ padding: '10px', fontWeight: 'bolder', color: 'green', border: '1px solid #ddd' }}>{caseListSummary?.completedCaseCount || 0}</td>
                                            <td style={{ padding: '10px', fontWeight: 'bolder', color: 'red', border: '1px solid #ddd' }}>{caseListSummary?.storePaymentStuckCount || 0}</td>
                                            <td style={{ padding: '10px', fontWeight: 'bolder', color: 'red', border: '1px solid #ddd' }}>{caseListSummary?.invoiceNotUploadedCount || 0}</td>
                                            <td style={{ padding: '10px', fontWeight: 'bolder', color: 'red', border: '1px solid #ddd' }}>{caseListSummary?.invoiceNotInspectedCount || 0}</td>
                                            <td style={{ padding: '10px', fontWeight: 'bolder', color: 'red', border: '1px solid #ddd' }}>{caseListSummary?.invoiceNotClosed || 0}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )}
                </div>


                {/* Case List Section */}
                <div className="call-list mt-4">
                    {caseListLoading ? (
                        <div style={{ textAlign: 'center', padding: '20px' }}>
                            <Spinner />
                        </div>
                    ) : (
                        <div style={{
                            border: '1px solid #ccc',
                            borderRadius: '8px',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                            padding: '10px'
                        }}>
                            <h6 style={{ textAlign: 'center', marginBottom: '16px', color: '#333', userSelect: 'none', }}>
                                Scan And Pay Cases
                            </h6>
                            {/* Scrollable Table */}
                            <div style={{ overflowX: 'auto' }}>
                                <table style={{
                                    width: '100%',
                                    minWidth: '1400px',
                                    borderCollapse: 'collapse',
                                    fontFamily: 'Arial, sans-serif',
                                    fontSize: '14px'
                                }}>
                                    <thead>
                                        <tr style={{
                                            backgroundColor: '#f8f9fa',
                                            borderBottom: '2px solid #dee2e6',
                                            userSelect: 'none',
                                        }}>
                                            {[
                                                'Cart ID', 'Digitisation ID', 'User Name', 'User Phone', 'VIP User',
                                                'Call Requested', 'Payout Attempted', 'Payout Closed', 'Invoice Uploaded', 'Reimbursement Request ID',
                                                'Invoice Inspected', 'Invoice Approved', 'Invoice Rejected',
                                                'Payout Amount', 'Invoice Approved Amount', 'Outstanding Amount', 'Invoice Closed'
                                            ].map((header, i) => (
                                                <th key={i} style={{
                                                    padding: '12px',
                                                    textAlign: 'left',
                                                    borderRight: '1px solid #e0e0e0',
                                                    whiteSpace: 'nowrap'
                                                }}>{header}</th>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {caseList.map((call, index) => {
                                            const isActive = this.state.cartId === call.cartId &&
                                                this.state.selectedRowIndex === index;
                                            return (
                                                <tr key={index} style={{
                                                    backgroundColor: isActive ? '#e7f3ff' : index % 2 === 0 ? '#fff' : '#f9f9f9',
                                                    borderBottom: '1px solid #ddd'
                                                }}>
                                                    <td style={cellStyle}>
                                                        <button
                                                            onClick={() => {
                                                                this.fetchCartDetails(call.cartId);
                                                                this.setState({ selectedRowIndex: index });
                                                            }}
                                                            style={{
                                                                padding: '6px 14px',
                                                                backgroundColor: '#007bff',
                                                                color: '#fff',
                                                                border: 'none',
                                                                borderRadius: '4px',
                                                                cursor: 'pointer',
                                                                fontSize: '13px'
                                                            }}
                                                            title="Fetch Cart Details"
                                                        >
                                                            {call.cartId}
                                                        </button>
                                                    </td>
                                                    <td style={cellStyle}>{call.digitisationRequestId}</td>
                                                    <td style={cellStyle}>{call.userName}</td>
                                                    <td style={cellStyle}>{call.userPhone}</td>
                                                    <td style={cellStyle}>{call.isVipUser ? 'Yes' : 'No'}</td>
                                                    <td style={cellStyle}>{call.isCallRequested ? 'Yes' : 'No'}</td>
                                                    <td style={cellStyle}>{call.isPayoutAttempted ? 'Yes' : 'No'}</td>
                                                    <td style={cellStyle}>{call.isPayoutClosed ? 'Yes' : 'No'}</td>
                                                    <td style={cellStyle}>{call.isInvoiceUploaded ? 'Yes' : 'No'}</td>
                                                    <td style={cellStyle}>{call.reimbursementRequestId}</td>
                                                    <td style={cellStyle}>{call.isInvoiceInspected ? 'Yes' : 'No'}</td>
                                                    <td style={cellStyle}>{call.isInvoiceApproved ? 'Yes' : 'No'}</td>
                                                    <td style={cellStyle}>{call.isInvoiceRejected ? 'Yes' : 'No'}</td>
                                                    <td style={cellStyle}>{call.payoutAmount}</td>
                                                    <td style={cellStyle}>{call.invoiceApprovedAmount}</td>
                                                    <td style={cellStyle}>{call.outStandingAmount}</td>
                                                    <td style={cellStyle}>{call.isInvoiceClosed ? 'Yes' : 'No'}</td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>

                            {/* Pagination outside scroll */}
                            <div style={{ textAlign: 'center', marginTop: '20px' }}>
                                <button
                                    onClick={this.handlePrevPage}
                                    disabled={offset <= 0}
                                    style={{
                                        padding: '6px 14px',
                                        backgroundColor: '#6c757d',
                                        color: '#fff',
                                        border: 'none',
                                        borderRadius: '4px',
                                        cursor: 'pointer',
                                        fontSize: '13px'
                                    }}
                                >
                                    Previous
                                </button>
                                <span style={{ margin: '0 12px' }}>Page {Math.floor(offset) + 1}</span>
                                <button
                                    onClick={this.handleNextPage}
                                    style={{
                                        padding: '6px 14px',
                                        backgroundColor: '#6c757d',
                                        color: '#fff',
                                        border: 'none',
                                        borderRadius: '4px',
                                        cursor: 'pointer',
                                        fontSize: '13px'
                                    }}
                                >
                                    Next
                                </button>
                            </div>
                        </div>
                    )}
                </div>
                <hr></hr>
                <section>
                    {caseList[selectedRowIndex] ?
                        (<>
                            <h6 style={{ textAlign: 'center', marginBottom: '16px', color: '#333', userSelect: 'none', }}>
                                Selected Case
                            </h6>
                            <div style={{ overflowX: 'auto' }}>
                                <table style={{
                                    width: '100%',
                                    minWidth: '1400px',
                                    borderCollapse: 'collapse',
                                    fontFamily: 'Arial, sans-serif',
                                    fontSize: '14px'
                                }}>
                                    <thead>
                                        <tr style={{
                                            backgroundColor: '#f8f9fa',
                                            borderBottom: '2px solid #dee2e6'
                                        }}>
                                            {[
                                                'Cart ID', 'Digitisation ID', 'User Name', 'User Phone', 'VIP User',
                                                'Call Requested', 'Payout Attempted', 'Payout Closed', 'Invoice Uploaded', 'Reimbursement Request ID',
                                                'Invoice Inspected', 'Invoice Approved', 'Invoice Rejected',
                                                'Payout Amount', 'Invoice Approved Amount', 'Outstanding Amount', 'Invoice Closed'
                                            ].map((header, i) => (
                                                <th key={i} style={{
                                                    padding: '12px',
                                                    textAlign: 'left',
                                                    borderRight: '1px solid #e0e0e0',
                                                    whiteSpace: 'nowrap'
                                                }}>{header}</th>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>

                                        <tr style={{
                                            backgroundColor: '#f9f9f9',
                                            borderBottom: '1px solid #ddd'
                                        }}>
                                            <td style={cellStyle}>{caseList[selectedRowIndex].cartId}</td>
                                            <td style={cellStyle}>{caseList[selectedRowIndex].digitisationRequestId}</td>
                                            <td style={cellStyle}>{caseList[selectedRowIndex].userName}</td>
                                            <td style={cellStyle}>{caseList[selectedRowIndex].userPhone}</td>
                                            <td style={cellStyle}>{caseList[selectedRowIndex].isVipUser ? 'Yes' : 'No'}</td>
                                            <td style={cellStyle}>{caseList[selectedRowIndex].isCallRequested ? 'Yes' : 'No'}</td>
                                            <td style={cellStyle}>{caseList[selectedRowIndex].isPayoutAttempted ? 'Yes' : 'No'}</td>
                                            <td style={cellStyle}>{caseList[selectedRowIndex].isPayoutClosed ? 'Yes' : 'No'}</td>
                                            <td style={cellStyle}>{caseList[selectedRowIndex].isInvoiceUploaded ? 'Yes' : 'No'}</td>
                                            <td style={cellStyle}>{caseList[selectedRowIndex].reimbursementRequestId}</td>
                                            <td style={cellStyle}>{caseList[selectedRowIndex].isInvoiceInspected ? 'Yes' : 'No'}</td>
                                            <td style={cellStyle}>{caseList[selectedRowIndex].isInvoiceApproved ? 'Yes' : 'No'}</td>
                                            <td style={cellStyle}>{caseList[selectedRowIndex].isInvoiceRejected ? 'Yes' : 'No'}</td>
                                            <td style={cellStyle}>{caseList[selectedRowIndex].payoutAmount}</td>
                                            <td style={cellStyle}>{caseList[selectedRowIndex].invoiceApprovedAmount}</td>
                                            <td style={cellStyle}>{caseList[selectedRowIndex].outStandingAmount}</td>
                                            <td style={cellStyle}>{caseList[selectedRowIndex].isInvoiceClosed ? 'Yes' : 'No'}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <hr />
                            <button
                                className="btn btn-primary"
                                onClick={this.getOrderList}
                                style={{
                                    padding: '6px 14px',
                                    backgroundColor: '#007bff',
                                    color: '#fff',
                                    border: 'none',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    fontSize: '13px'
                                }}
                            >
                                Fetch Order List
                            </button>

                            {/* Order List Section */}
                            <div className="order-list mt-4">
                                {orderListLoading ? (
                                    <div style={{ textAlign: 'center', padding: '20px' }}>
                                        <Spinner />
                                    </div>
                                ) : (
                                    <div
                                        style={{
                                            border: '1px solid #ddd',
                                            borderRadius: '8px',
                                            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                            padding: '12px',
                                            backgroundColor: '#fff',
                                            fontFamily: 'Arial, sans-serif',
                                            fontSize: '14px',
                                        }}
                                    >
                                        <h6 style={{ textAlign: 'center', marginBottom: '16px', color: '#333', userSelect: 'none', }}>
                                            Order List
                                        </h6>

                                        <div
                                            style={{
                                                maxHeight: '300px',
                                                overflowY: 'auto',
                                                border: '1px solid #eee',
                                                borderRadius: '6px',
                                            }}
                                        >
                                            <table
                                                style={{
                                                    width: '100%',
                                                    borderCollapse: 'collapse',
                                                    minWidth: '600px',
                                                }}
                                            >
                                                <thead>
                                                    <tr style={{ backgroundColor: '#f8f9fa', borderBottom: '2px solid #dee2e6' }}>
                                                        {[
                                                            'Order Id',
                                                            'Placed On',
                                                            'Payout Amount',
                                                            'Payout Transaction Status',
                                                            'Payout Transaction Message',
                                                            'Current Wallet Deduction',
                                                        ].map((header, i) => (
                                                            <th
                                                                key={i}
                                                                style={{
                                                                    padding: '12px',
                                                                    textAlign: 'left',
                                                                    color: '#555',
                                                                    fontWeight: '600',
                                                                    borderRight: i !== 4 ? '1px solid #e0e0e0' : 'none',
                                                                    whiteSpace: 'nowrap',
                                                                }}
                                                            >
                                                                {header}
                                                            </th>
                                                        ))}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {orderList.map((order, index) => (
                                                        <tr
                                                            key={index}
                                                            style={{
                                                                backgroundColor: index % 2 === 0 ? '#fff' : '#f9f9f9',
                                                                borderBottom: '1px solid #eaeaea',
                                                            }}
                                                        >
                                                            <td style={{ padding: '10px' }}>{order.orderId}</td>
                                                            <td style={{ padding: '10px' }}>{order.placedOn}</td>
                                                            <td style={{ padding: '10px' }}>{order.payoutAmount}</td>
                                                            <td style={{ padding: '10px' }}>{order.payoutTransactionStatus}</td>
                                                            <td style={{ padding: '10px' }}>{order.payoutTransactionMessage}</td>
                                                            <td style={{ padding: '10px' }}>{order.currentWalletDeduction}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                )}
                            </div>

                            <hr />
                            <button
                                className="btn btn-primary"
                                onClick={this.getCallList}
                                style={{
                                    padding: '6px 14px',
                                    backgroundColor: '#007bff',
                                    color: '#fff',
                                    border: 'none',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    fontSize: '13px'
                                }}
                            >
                                Fetch Call History
                            </button>

                            {/* Call List Section */}
                            <div className="call-list mt-4">
                                {callListLoading ? (
                                    <div style={{ textAlign: 'center', padding: '20px' }}>
                                        <Spinner />
                                    </div>
                                ) : (
                                    <div
                                        style={{
                                            border: '1px solid #ddd',
                                            borderRadius: '8px',
                                            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                            padding: '12px',
                                            backgroundColor: '#fff',
                                            fontFamily: 'Arial, sans-serif',
                                            fontSize: '14px',
                                        }}
                                    >
                                        <h6 style={{ textAlign: 'center', marginBottom: '16px', color: '#333', userSelect: 'none', }}>
                                            Call History
                                        </h6>

                                        <div
                                            style={{
                                                maxHeight: '300px',
                                                overflowY: 'auto',
                                                border: '1px solid #eee',
                                                borderRadius: '6px',
                                            }}
                                        >
                                            <table
                                                style={{
                                                    width: '100%',
                                                    borderCollapse: 'collapse',
                                                    minWidth: '600px',
                                                }}
                                            >
                                                <thead>
                                                    <tr style={{ backgroundColor: '#f8f9fa', borderBottom: '2px solid #dee2e6' }}>
                                                        {['Ops User Name', 'Ops User Phone', 'Call Status', 'Start Time', 'End Time', 'Duration'].map((head, i) => (
                                                            <th
                                                                key={i}
                                                                style={{
                                                                    padding: '12px',
                                                                    textAlign: 'left',
                                                                    color: '#555',
                                                                    fontWeight: '600',
                                                                    borderRight: i !== 5 ? '1px solid #e0e0e0' : 'none'
                                                                }}
                                                            >
                                                                {head}
                                                            </th>
                                                        ))}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {callList.map((call, index) => (
                                                        <tr
                                                            key={index}
                                                            style={{
                                                                backgroundColor: index % 2 === 0 ? '#fff' : '#f9f9f9',
                                                                borderBottom: '1px solid #eaeaea',
                                                            }}
                                                        >
                                                            <td style={{ padding: '10px' }}>{call.opsUserName}</td>
                                                            <td style={{ padding: '10px' }}>{call.opsUserPhone}</td>
                                                            <td style={{ padding: '10px' }}>{call.callStatus}</td>
                                                            <td style={{ padding: '10px' }}>{call.startTime}</td>
                                                            <td style={{ padding: '10px' }}>{call.endTime}</td>
                                                            <td style={{ padding: '10px' }}>{call.duration}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                )}
                            </div>


                            <hr />
                            <button
                                className="btn btn-primary"
                                onClick={this.getUpiScanList}
                                style={{
                                    padding: '6px 14px',
                                    backgroundColor: '#007bff',
                                    color: '#fff',
                                    border: 'none',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    fontSize: '13px'
                                }}
                            >
                                Fetch Upi Scan List
                            </button>

                            {/* Call List Section */}
                            <div className="call-list mt-4">
                                {upiScanListLoading ? (
                                    <div style={{ textAlign: 'center', padding: '20px' }}>
                                        <Spinner />
                                    </div>
                                ) : (
                                    <div
                                        style={{
                                            border: '1px solid #ddd',
                                            borderRadius: '8px',
                                            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                            padding: '12px',
                                            backgroundColor: '#fff',
                                            fontFamily: 'Arial, sans-serif',
                                            fontSize: '14px',
                                        }}
                                    >
                                        <h6 style={{ textAlign: 'center', marginBottom: '16px', color: '#333', userSelect: 'none', }}>
                                            Scanned Upi List
                                        </h6>

                                        <div
                                            style={{
                                                maxHeight: '300px',
                                                overflowY: 'auto',
                                                border: '1px solid #eee',
                                                borderRadius: '6px',
                                            }}
                                        >
                                            <table
                                                style={{
                                                    width: '100%',
                                                    borderCollapse: 'collapse',
                                                    minWidth: '300px',
                                                }}
                                            >
                                                <thead>
                                                    <tr style={{ backgroundColor: '#f8f9fa', borderBottom: '2px solid #dee2e6' }}>
                                                        <th
                                                            style={{
                                                                padding: '12px',
                                                                textAlign: 'left',
                                                                borderRight: '1px solid #e0e0e0',
                                                                color: '#555',
                                                                fontWeight: '600',
                                                            }}
                                                        >
                                                            UPI ID
                                                        </th>
                                                        <th
                                                            style={{
                                                                padding: '12px',
                                                                textAlign: 'left',
                                                                color: '#555',
                                                                fontWeight: '600',
                                                            }}
                                                        >
                                                            Scan Status
                                                        </th>
                                                        <th
                                                            style={{
                                                                padding: '12px',
                                                                textAlign: 'left',
                                                                color: '#555',
                                                                fontWeight: '600',
                                                            }}
                                                        >
                                                            Message
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {upiScanList.map((item, index) => (
                                                        <tr
                                                            key={index}
                                                            style={{
                                                                backgroundColor: index % 2 === 0 ? '#fff' : '#f9f9f9',
                                                                borderBottom: '1px solid #eaeaea',
                                                            }}
                                                        >
                                                            <td style={{ padding: '10px' }}>{item.upiId}</td>
                                                            <td style={{ padding: '10px' }}>{item.status}</td>
                                                            <td style={{ padding: '10px' }}>{item.message}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                )}
                            </div>

                            <hr />

                            {/* Cart Details Section */}
                            <div className="cart-details mt-4">
                                <h3>Cart Details</h3>
                                {loading ? (
                                    <div className="text-center">
                                        <Spinner />
                                    </div>
                                ) : cartDetails ? (
                                    <div className="cart-info">
                                            <div style={{
                                                display: 'flex',
                                                flexWrap: 'wrap', // wraps if screen is too small
                                                gap: '20px',
                                                alignItems: 'center',
                                                justifyContent: 'space-between',
                                                marginBottom: '20px'
                                            }}>
                                                <p><strong>Cart ID:</strong> {cartDetails.cartId || cartId}</p>
                                                <p><strong>Total Amount:</strong> ₹{cartDetails.totalAmount}</p>
                                                <p><strong>Requested Amount:</strong> ₹{cartDetails.requestedAmount}</p>
                                                <p><strong>Approved Amount:</strong> ₹{cartDetails.approvedAmount}</p>
                                                <p>
                                                    <strong>Prescription URL:</strong>{' '}
                                                    <a href={cartDetails.prescriptionUrl} target="_blank" rel="noopener noreferrer">
                                                        View Prescription
                                                    </a>
                                                </p>
                                            </div>
                                        <hr />

                                        <div className="cart-items" style={{ marginTop: '20px' }}>
                                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                {/* Covered Items */}
                                                <div
                                                    style={{
                                                        width: '48%',
                                                        border: '1px solid #ddd',
                                                        padding: '15px',
                                                        borderRadius: '5px',
                                                        backgroundColor: '#f9f9f9',
                                                    }}
                                                >
                                                    <h4>Covered Items</h4>
                                                    {cartDetails.items.covered && cartDetails.items.covered.length > 0 ? (
                                                        <ul style={{ listStyleType: 'none', padding: 0 }}>
                                                            {cartDetails.items.covered.map((item, index) => (
                                                                <li key={index} style={{ marginBottom: '5px' }}>
                                                                    {item.name} (₹{item.mrp} x {item.quantity} pcs)
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    ) : (
                                                        <p>No covered items.</p>
                                                    )}
                                                </div>

                                                {/* Uncovered Items */}
                                                <div
                                                    style={{
                                                        width: '48%',
                                                        border: '1px solid #ddd',
                                                        padding: '15px',
                                                        borderRadius: '5px',
                                                        backgroundColor: '#f9f9f9',
                                                    }}
                                                >
                                                    <h4>Uncovered Items</h4>
                                                    {cartDetails.items.uncovered && cartDetails.items.uncovered.length > 0 ? (
                                                        <ul style={{ listStyleType: 'none', padding: 0 }}>
                                                            {cartDetails.items.uncovered.map((item, index) => (
                                                                <li key={index} style={{ marginBottom: '5px' }}>
                                                                    {item.name} (₹{item.mrp} x {item.quantity} pcs)
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    ) : (
                                                        <p>No uncovered items.</p>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        <hr />
                                    </div>
                                ) : (
                                    <p>No detail found.</p>
                                )}
                                <div className="cart-details-container" style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px' }}>
                                    {/* Update Approved Amount Section */}
                                    <div
                                        className="update-amount-section"
                                        style={{
                                            width: '48%',
                                            border: '1px solid #ddd',
                                            padding: '15px',
                                            borderRadius: '5px',
                                            backgroundColor: '#f9f9f9',
                                        }}
                                    >
                                        <h4>Update Approved Amount</h4>
                                        <div className="form-group">
                                            <input
                                                type="number"
                                                value={this.state.approvedAmount ?? ''}
                                                onChange={(e) => this.setState({ approvedAmount: e.target.value })}
                                                placeholder="Enter new approved amount"
                                                className="form-control"
                                                style={{ marginBottom: '10px' }}
                                            />
                                        </div>
                                        <button
                                            onClick={this.handleUpdateApprovedAmount}
                                            className="btn btn-primary"
                                            style={{
                                                padding: '6px 14px',
                                                backgroundColor: '#007bff',
                                                color: '#fff',
                                                border: 'none',
                                                borderRadius: '4px',
                                                cursor: 'pointer',
                                                fontSize: '13px'
                                            }}
                                            disabled={updating}
                                        >
                                            {updating ? <Spinner size="sm" /> : "Update Amount"}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </>)
                        : (<></>)}
                    <hr />
                </section>
            </section>
        );
    }
}

const mapStateToProps = (state) => ({
    authToken: state.user.authToken,
    user: state.user,
});

export default connect(mapStateToProps)(PharmacyScanAndPayHome);
